"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (window) {
  var Breakpoints = /*#__PURE__*/function () {
    function Breakpoints() {
      _classCallCheck(this, Breakpoints);

      throw new window.Error("You can't create instances of the class [Breakpoint]. Please, use the static methods.");
    } //MEDIA QUERY


    _createClass(Breakpoints, null, [{
      key: "matches",
      // MATCH MEDIA
      value: function matches(rule, breakpoint) {
        return window.matchMedia("only screen and (" + rule + ": " + breakpoint + "px)").matches;
      }
    }, {
      key: "XS",
      get: function get() {
        return 0;
      }
    }, {
      key: "SM",
      get: function get() {
        return 576;
      }
    }, {
      key: "MD",
      get: function get() {
        return 768;
      }
    }, {
      key: "LG",
      get: function get() {
        return 992;
      }
    }, {
      key: "XL",
      get: function get() {
        return 1200;
      }
    }, {
      key: "XXL",
      get: function get() {
        return 1440;
      }
    }, {
      key: "XXXL",
      get: function get() {
        return 1680;
      }
    }, {
      key: "XXXXL",
      get: function get() {
        return 1920;
      }
    }, {
      key: "GUTTER_XS",
      get: function get() {
        return 15;
      }
    }, {
      key: "GUTTER_SM",
      get: function get() {
        return 15;
      }
    }, {
      key: "GUTTER_MD",
      get: function get() {
        return 15;
      }
    }, {
      key: "GUTTER_LG",
      get: function get() {
        return 15;
      }
    }, {
      key: "GUTTER_XL",
      get: function get() {
        return 15;
      }
    }, {
      key: "GUTTER_XXL",
      get: function get() {
        return 15;
      }
    }, {
      key: "GUTTER_XXXL",
      get: function get() {
        return 15;
      }
    }, {
      key: "GUTTER_XXXXL",
      get: function get() {
        return 15;
      } //MEDIA QUERY RULES

    }, {
      key: "MIN_WIDTH",
      get: function get() {
        return "min-width";
      }
    }, {
      key: "MAX_WIDTH",
      get: function get() {
        return "max-width";
      }
    }]);

    return Breakpoints;
  }();

  window.Breakpoints = Breakpoints;
})(window);
